import React from 'react';
import { Box, ButtonV2, Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { useTranslation } from '@shared/core';
import { JoyAiV2 } from '@withjoy/joykit/icons';
import { AudioPlayer } from '../AudioPlayer';
import { FiltersOrder } from './FiltersOrder';
import { ScoringPriorityField } from '@graphql/generated';

const AUDIO_URL = 'https://withjoy.com/assets/public/travel/accommodations-filters.mp3';

interface FiltersProps {
  handleOnClickRevealMatches: () => void;
  handleOnChangeOrder: (scoringPriorityFields: ReadonlyArray<ScoringPriorityField>) => void;
}

export const Filters = ({ handleOnChangeOrder, handleOnClickRevealMatches }: FiltersProps) => {
  const { t } = useTranslation('websiteEditor');
  const filtersTrans = t('venueFilters');
  return (
    <Flex
      flex={1}
      flexDirection="column"
      gap={7}
      alignItems="center"
      justifyContent="center"
    >
      <Flex
        flexDirection="column"
        gap={5}
        alignItems="center"
        paddingX={{ _: 6, md: 0 }}
      >
        <JoyAiV2 size={64} />
        <Box
          typographyVariant="hed3"
          textAlign="center"
          maxWidth={{ _: '100%', md: pxToRem(328) }}
        >
          {filtersTrans.title()}
        </Box>
      </Flex>
      <AudioPlayer
        id="AccommodationsFiltersAudio"
        url={AUDIO_URL}
        preload="auto"
        width={pxToRem(153)}
      >
        {filtersTrans.audioCta()}
      </AudioPlayer>
      <FiltersOrder handleOnChangeOrder={handleOnChangeOrder} />
      <Flex
        width="100%"
        maxWidth={{ _: '100%', md: pxToRem(340) }}
        flexDirection="column"
        justifyContent="center"
        borderTop={{ _: '1px solid', sm2: 'none' }}
        borderTopColor="mono3"
        paddingX={{ _: 6, md: 0 }}
        paddingY={{ _: 5, md: 0 }}
        position={{ _: 'sticky', sm2: 'relative' }}
        backgroundColor="white"
        bottom={0}
        gap={5}
        boxShadow={'none'}
      >
        <ButtonV2
          typographyVariant="button2"
          intent="newPrimary"
          textAlign="center"
          shape="rounded"
          fullWidth
          onClick={handleOnClickRevealMatches}
        >
          {filtersTrans.cta()}
        </ButtonV2>
      </Flex>
    </Flex>
  );
};
